import React from "react";
import { Navigate } from "react-router-dom";

const ProviderRegisterPlaceholder = () => {
  const isLoggedIn = Boolean(sessionStorage.getItem("token"));
  const target = isLoggedIn ? "/home/provider-services" : "/login?next=/home/provider-services";
  return <Navigate to={target} replace />;
};

export default ProviderRegisterPlaceholder;
